import { render, staticRenderFns } from "./CartTotal.vue?vue&type=template&id=44f96b81&scoped=true&"
import script from "./CartTotal.vue?vue&type=script&lang=js&"
export * from "./CartTotal.vue?vue&type=script&lang=js&"
import style0 from "./CartTotal.vue?vue&type=style&index=0&id=44f96b81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f96b81",
  null
  
)

export default component.exports